// export const API_BASE = "http://localhost/photo/backend";
export const API_BASE = "https://mdqapps.online/photo_app/API";